import { type ReactElement } from 'react';
import { Button, Dialog, Stack, Text } from '@citibox-panel/ui';
import type { ExcludedUser } from '../lib/excludedUser';

export interface RemoveConfirmDialogProps {
  user: ExcludedUser | null;
  carrierName: string;
  isRemoving: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

// One step, naming WHO: a «QUITAR» per row is a plausible mis-click, and removing hands the carrier
// back a recipient Producto excluded on purpose. Not opened pre-armed: focus starts on the way out.
//
// TODO: i18n — copy en ES hasta Fase 1.
export function RemoveConfirmDialog({
  user,
  carrierName,
  isRemoving,
  onConfirm,
  onCancel,
}: RemoveConfirmDialogProps): ReactElement {
  return (
    <Dialog
      open={user !== null}
      onClose={onCancel}
      label="Confirmar quitar la exclusión"
      maxWidth="xs"
      actions={
        <>
          <Button variant="outlined" color="neutral" autoFocus onClick={onCancel}>
            Cancelar
          </Button>
          <Button color="error" loading={isRemoving} onClick={onConfirm}>
            Quitar
          </Button>
        </>
      }
    >
      <Stack spacing={1}>
        <Text variant="subtitle1">
          {user === null
            ? ''
            : `Vas a quitar a ${user.name} (${user.phone}) de la lista de exclusión de ${carrierName}.`}
        </Text>
        <Text variant="body2">{`Volverá a poder recibir reservas de ${carrierName}.`}</Text>
      </Stack>
    </Dialog>
  );
}
